import { css } from '@emotion/react'

export const pageWrapper = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export const container = css`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
`

export const formWrapper = css`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`

export const formOuter = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 960px;
`

export const formContainer = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
`

export const fileRow = css`
  display: flex;
  align-items: center;
  gap: 16px;
`
